define(['layout/util/layout', 'santa-components-layout'], function (layout, santaComponentsLayout) {
    'use strict';

    layout.registerCustomDomChangesFunction(santaComponentsLayout.siteButtonLayout.compType, santaComponentsLayout.siteButtonLayout);
});
